exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prematch-nav{display:flex;flex-direction:row;background:var(--white)}.prematch-nav__item{background:none;border:none;margin:0;padding:15px 10px;font-size:var(--font-normal);color:var(--light-black);font-weight:var(--font-weight-normal);text-decoration:none}.prematch-nav__item.active{font-weight:var(--font-weight-bold);color:var(--black)}", ""]);

// exports
